import React, { Component } from "react";
import { connect } from "react-redux";

import Users from "./Users";
import FilterBar from "./FilterBar";
import Sidebar from "./Sidebar";
import BubblesListContainer from "../BubblesList/BubblesListContainer";
import { BUBBLE_EVENTS } from "Config";

import { selectRouting } from "Selectors";

import _ from "i18n";

export class Settings extends Component {
  allUserSelected = () => {
    const { users, selectedUsers } = this.props;

    return users.length === selectedUsers.length;
  };

  renderBubbles() {
    const { selectedUsers } = this.props;
    const bubbles = [
      {
        icon: "i-plus-outline",
        label: _("Add new user"),
        event: BUBBLE_EVENTS.ADD_NEW_USER
      },
      {
        icon: "i-ckeck-outline",
        label: _("Select all"),
        event: BUBBLE_EVENTS.SELECT_ALL_USERS,
        hidden: this.allUserSelected()
      },
      {
        icon: "i-close-outline",
        label: _("Deselect All"),
        event: BUBBLE_EVENTS.DESELECT_ALL_USERS,
        hidden: !this.allUserSelected()
      },
      {
        icon: "i-settings",
        label: _("Settings"),
        event: BUBBLE_EVENTS.HANDLE_CLICK_SETTING,
        disabled: selectedUsers.length < 1
      },
      {
        icon: "i-tools",
        label: _("Preferences"),
        event: BUBBLE_EVENTS.HANDLE_CLICK_SETTING,
        disabled: selectedUsers.length > 0
      }
    ];
    return <BubblesListContainer bubbles={bubbles} active={true} />;
  }

  render() {
    return (
      <div id="main" className="settings page">
        <div className="settings__filter-bar grid-x align-center">
          <FilterBar />
        </div>
        <div id="setting-users" className="grid-x align-center">
          <Users />
        </div>
        {this.renderBubbles()}
        <Sidebar />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  routing: selectRouting(state),
  users: state.users.items,
  usersFetched: state.users.fetched,
  selectedUsers: state.settings.selectedUsers,
  sidebarOpened: state.settings.sidebarOpened
});

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings/index.js